import { KYMW1406Model } from '../kymw1406.model';
import { RequestGetGoodsInfoListModel } from '../../kymw1400/vo/request-get-goods-info-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報を取得する。
 *
 * @export
 * @class GetGoodsInfoListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetGoodsInfoListService extends PlessJsonResponderSub<any> {

  private vo: RequestGetGoodsInfoListModel = null;
  private model: KYMW1406Model = null;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsInfoListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        KomaID: this.vo.komaID,
        OrderGoodsFlg: this.vo.orderGoodsFlg
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1406Model} model
   * @param {RequestGetGoodsInfoListModel} vo
   * @memberof GetGoodsInfoListService
   */
  execute(model: KYMW1406Model, vo: RequestGetGoodsInfoListModel, successFunc?: () => void) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGoodsInfoList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsInfoListService
   */
  success(data: any) {
    // 結果データの編集
    this.model.updateServerResponse(data);
    if (this.successFunc) {
      this.successFunc();
    }
  }
}
